import {
  SEARCH_INSTITUTION_REQUEST,
  SEARCH_INSTITUTION_SUCCESS,
  SEARCH_INSTITUTIONS_REQUEST,
  SEARCH_INSTITUTIONS_SUCCESS,
  RESET_SUGGESTIONS,
  statusType
} from '../../actions'

const initial = {
  institution: {},
  suggestions: [],
  status: statusType.IDLE
}

const institution = (state = initial, action) => {
  switch (action.type) {
    case SEARCH_INSTITUTION_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }

    case SEARCH_INSTITUTION_SUCCESS:
      return {
        ...state,
        institution: action.payload || {},
        status: statusType.SUCCESS
      }

    case SEARCH_INSTITUTIONS_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }

    case SEARCH_INSTITUTIONS_SUCCESS:
      return {
        ...state,
        suggestions: action.payload || [],
        status: statusType.SUCCESS
      }

    case RESET_SUGGESTIONS:
      return {
        ...initial
      }

    default:
      return state
  }
}

export default institution
